<div class="relative">
  <ng-template #simplifiedInvoiceTooltip>
    <div class="flex align-items-start justify-content-center flex-column">
      Ative esta opção para ocultar informações pessoais (CPF, número do conselho, registro de especialidade) da descrição da nota enviada ou emitida.
    </div>
  </ng-template>

  <split-steps
    *ngIf="isLoadingProfessional == false && (profissaoLista$ | async)?.length && (professionalState$ | async)?.type !='loading' && !isUploadLoading && (selectProfessionalServiceState$ | async)?.type != 'loading'"
    #steps [activeIndex]="activeIndex" (stepChange)="onActiveIndexChanged($event)">
    <split-step [passo]="0">
      <ng-container [formGroup]="form">
        <div class="switch-line mb-3 flex align-items-center " [formGroup]="form">
          <p-inputSwitch class="flex" formControlName="split"></p-inputSwitch>
          <span class="label-switch">Split e Nota Fiscal</span>
        </div>
        <form class="grid mt-0 mb-6 p-fluid" [formGroup]="form">
          <div class="linha col-8 mt-3">
            <span class="p-float-label" formGroupName="userInfo">
              <input (keydown)="validateChar($event)" pInputText id="nome-completo" formControlName="name"
                class="w-full" />
              <label class="pl-1 h-1rem flex align-items-center" for="cpf">Nome Completo <img class="pl-1"
                  src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
            </span>
          </div>
          <div class="col-4 mt-3">
            <span class="p-float-label" formGroupName="userInfo">
              <p-inputMask [class.p-disabled]="isEdit" [unmask]="true" [autoClear]="true" id="cpf" formControlName="taxId" mask="999.999.999-99">
              </p-inputMask>
              <label class="pl-1 h-1rem flex align-items-center" for="cpf">CPF <img class="pl-1"
                  src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
            </span>
          </div>
          <div class="col-6 mt-3">
            <span class="p-float-label" formGroupName="userInfo">
              <input pInputText mask="(00) 00000-0000||(00) 0000-0000" id="telefone" formControlName="contactNumber" />
              <!--<p-inputMask [unmask]="true" [autoClear]="false" id="telefone" formControlName="contactNumber"
                mask="(99) 99999-9999"> </p-inputMask>-->
              <label class="pl-1 h-1rem flex align-items-center" for="cpf">Celular
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>
          <div class="col-6 mt-3">
            <span class="p-float-label" formGroupName="userInfo">
              <input pInputText type="email" formControlName="email" id="email" />
              <label class="pl-1 h-1rem flex align-items-center" for="cpf">Email <img class="pl-1"
                  src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
            </span>
          </div>
          <div class="mt-3 col-4">
            <span class="p-float-label">
              <p-dropdown inputId="multiselect" [options]="(profissaoLista$ | async)!" [filter]="true" filterBy="name"
                optionLabel="name" optionValue="@id" formControlName="profession"
                (onChange)="professionChange()"></p-dropdown>
              <label class="pl-1 h-1rem flex align-items-center" for="cpf">Profissão <img class="pl-1"
                  src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
            </span>
          </div>
          <div class="col-4 mt-3" [ngClass]="especialidadeLista.length > 0? '' : 'inativo'">
            <span class="p-float-label">
              <p-multiSelect [filter]="true" filterBy="name" inputId="multiselect"
                [disabled]="especialidadeLista.length == 0" [options]="especialidadeLista" formControlName="specialties"
                optionLabel="name" optionValue="@id"></p-multiSelect>
              <label for="multiselect">Especialidade</label>
            </span>
          </div>
          <div class="col-4 mt-3">
            <span class="p-float-label">
              <p-multiSelect [appendTo]="'body'" [filter]="true" filterBy="unitName" inputId="multiselect"
                [options]="(unidadeLista$ | async)!" formControlName="units" optionLabel="unitName" optionValue="@id"
                [selectedItemsLabel]="'{0} unidades selecionadas'"></p-multiSelect>
              <label class="pl-1 h-1rem flex align-items-center" for="cpf">Unidades <img class="pl-1"
                  src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
            </span>
          </div>

          <div class="linha col-6 mt-3">
            <span class="p-float-label">
              <input pKeyFilter="int" pInputText id="nome-completo" formControlName="professionalRegister" class="w-full" />
              <label htmlFor="nome-completo">Número do Conselho </label>
            </span>
          </div>
          <div class="linha col-6 mt-3">
            <span class="p-float-label">
              <input pInputText id="nome-completo" formControlName="specialtyRegister" class="w-full" />
              <label htmlFor="nome-completo">Registro de Especialidades </label>
            </span>
          </div>

          <ng-container *ngIf="form.value.split" formGroupName="taxInfo">
            <div class="col-4 mt-3">
              <span class="p-float-label" formGroupName="bankAccount">
                <p-dropdown inputId="dropdown" [autoDisplayFirst]="false" [options]="bankList" formControlName="bank"
                  appendTo="body" optionValue="@id" [filter]="true" [filterFields]="['name', 'code']">
                  <ng-template let-bank pTemplate="selectedItem">
                    {{ formatNumberBank(bank) }}
                  </ng-template>
                  <ng-template let-bank pTemplate="item">
                    {{ formatNumberBank(bank) }}
                  </ng-template>
                </p-dropdown>
                <label class="pl-1 h-1rem flex align-items-center" for="cpf">Banco <img class="pl-1"
                    src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
              </span>
            </div>

            <div class="col-2 mt-3">
              <span class="p-float-label" formGroupName="bankAccount">
                <input pInputText maxlength="4" pKeyFilter="int" id="agencia" formControlName="bankBranch" />
                <!-- <p-inputMask id="agencia" mask="9999" formControlName="bankBranch"> </p-inputMask> -->
                <label class="pl-1 h-1rem flex align-items-center" for="cpf">Agência <img class="pl-1"
                    src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
              </span>
            </div>

            <div class="col-4 mt-3">
              <span class="p-float-label" formGroupName="bankAccount">
                <input pInputText maxlength="13" pKeyFilter="int" id="conta-corrente"
                  formControlName="checkingAccount" />
                <!-- <p-inputMask id="conta-corrente" mask="9999-9999-99" formControlName="checkingAccount"> </p-inputMask> -->
                <label class="pl-1 h-1rem flex align-items-center" for="cpf">Conta Corrente <img class="pl-1"
                    src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
              </span>
            </div>
            <div class="col-2 mt-3">
              <span class="p-float-label" formGroupName="bankAccount">
                <input pInputText pKeyFilter="int" maxlength="2" id="digit" formControlName="digit" />
                <!-- <p-inputMask id="conta-corrente" mask="9999-9999-99" formControlName="checkingAccount"> </p-inputMask> -->
                <label class="pl-1 h-1rem flex align-items-center" for="digit">Digito<img class="pl-1"
                    src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="form.get('id')?.value == null">
            <div class="col-6 mt-3">
              <span class="p-float-label">
                <!-- <input pInputText id="senha" formControlName='password' /> -->
                <p-password formControlName="password" id="senha" [feedback]="false" [toggleMask]="true"></p-password>
                <label htmlFor="senha" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Senha
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div>
            <div class="col-6 mt-3">
              <span class="p-float-label">
                <!-- <input pInputText id="repetirSenha" formControlName='confirmPassword' /> -->
                <p-password formControlName="confirmPassword" id="repetirSenha" [feedback]="false"
                  [toggleMask]="true"></p-password>
                <label htmlFor="repetirSenha" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Repetir a Senha
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div>
          </ng-container>
          <!--
          <div class="col-12 mt-3">
            <span class="p-float-label">
              <textarea inputId="textarea" rows="3" style="resize: none" cols="30" pInputTextarea
                formControlName="resume"></textarea>
              <label for="textarea" class="text-xs pl-1 h-1rem flex align-items-center">Curriculo</label>
            </span>
          </div>
          -->
        </form>
      </ng-container>
    </split-step>

    <split-step [passo]="1">
      <!-- <p>Contabilidade com 3 escolhas</p> -->
      <section class="pb-6">
        <div class="flex flex-column mt-3">
          <div class="flex justify-content-between align-items-center h-3rem p-4 border-round-top-lg"
            style="background-color: #f5f5f5; color: #585050">
            <h6 class="title-header-text">Tipo</h6>
            <div class="flex justify-content-center align-items-center w-8rem h-2rem">
              <h6 class="title-header-text">Liberação</h6>
            </div>
          </div>
          <div class="flex flex-column">
            <div *ngFor="let item of listContabil" class="h-5rem flex justify-content-between align-items-center px-4"
              style="border-bottom: 1px solid #ddd">
              <h4 class="title-text">{{item.name}}</h4>
              <button [ngClass]="{'button-selected': item.type == form.get('type')?.value}"
                (click)="selecionarContabilidade(item.type)"
                class="button flex justify-content-center align-items-center w-8rem h-2rem border-round-md">
                <span>{{item.type == form.get('type')?.value ? 'Selecionado' : 'Selecionar' }}</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </split-step>

    <split-step [passo]="2" [ignoreStep]="true">
      <!-- <p>conteudo de contabilidade</p> -->
      <ng-container *ngIf="contabilidadeSelecionada === 'pessoa-fisica'">
        <form [formGroup]="form" class="pb-6 flex flex-column" style="margin-top: -35px;">
          <span class="mb-6 mt-2 tipo-contabilidade">Cadastro para recebimento em Pessoa Física</span>
          <div class="grid p-fluid">

            <div class="col-6 mb-3">
              <span class="p-float-label">
                <p-inputMask [unmask]="true" id="dataNascimento" mask="99/99/9999" formControlName="birthdate">
                </p-inputMask>
                <label htmlFor="dataNascimento" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Data de Nascimento
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div>

            <div class="col-6 mb-3">
              <span class="p-float-label">
                <p-inputNumber formControlName="monthlyIncome" id="valor" mode="currency" currency="BRL" locale="pt-BR"
                  currencyDisplay="symbol"> </p-inputNumber>
                <label htmlFor="valor" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Renda Mensal
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div>

            <div class="col-4 mb-3">
              <span class="p-float-label" formGroupName="address">

                <p-inputMask #cep id="cep" [unmask]="true" [autoClear]="false" formControlName="postalCode"
                  mask="99999-999" (onComplete)="autoCompleteAddress(cep.value!, null)">
                </p-inputMask>
                <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center">
                  CEP
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>


              </span>
            </div>

            <div class="col-4 mb-3">
              <span class="p-float-label" formGroupName="address">

                <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                  (onChange)="loadCitiesByUF($event.value)" [filter]="true" filterBy="name" [options]="stateList"
                  optionLabel="name" optionValue="uf" id="estado" formControlName="state"></p-dropdown>

                <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Estado <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                    alt="alerta-campo-vazio" />
                </label>


              </span>
            </div>

            <div class="col-4 mb-3">
              <span class="p-float-label" formGroupName="address">

                <div class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
                  *ngIf="isLoadingCities">
                  Aguarde...

                </div>

                <span class="p-float-label" *ngIf="!isLoadingCities">
                  <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'" [filter]="true" filterBy="nome"
                    [options]="citiesListPF" id="cidade" formControlName="city" optionLabel="nome" optionValue="id"
                    inputId="float-label"></p-dropdown>
                  <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                    Cidade <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                      alt="alerta-campo-vazio" />
                  </label>
                </span>
              </span>
            </div>

            <div class="col-8 mb-3">
              <span class="p-float-label" formGroupName="address">
                <input pInputText id="logradouro" formControlName="streetAddress" />
                <label htmlFor="logradouro" class="text-xs pl-1 h-1rem flex align-items-center">Logradouro <img
                    class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                    alt="alerta-campo-vazio" /></label>
              </span>
            </div>

            <div class="col-4 mb-3">
              <span class="p-float-label" formGroupName="address">
                <input pInputText id="bairro" formControlName="district" />
                <label htmlFor="bairro" class="text-xs pl-1 h-1rem flex align-items-center">Bairro <img class="pl-1"
                    src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
              </span>
            </div>

            <div class="col-4 mb-3">
              <span class="p-float-label" formGroupName="address">
                <input pInputText id="numero" formControlName="number" />
                <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center">Número <img class="pl-1"
                    src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>

              </span>
            </div>

            <div class="col-8 mb-3">
              <span class="p-float-label" formGroupName="address">
                <input pInputText id="complemento" formControlName="address2" />
                <label htmlFor="complemento" class="text-xs pl-2">Complemento
                </label>
              </span>
            </div>

          </div>
          <span class="text-xs flex align-items-center texto-info mb-2">
            <p-checkbox class="mr-2" [binary]="true" inputId="binary" formControlName="acceptTermsPf"></p-checkbox>
            Estou ciente que irei receber em minha pessoa física e Split Pay não
            se responsabiliza pelo método escolhido
          </span>
        </form>
      </ng-container>

      <ng-container *ngIf="contabilidadeSelecionada === 'pessoa-juridica'">
        <form [formGroup]="form" class="pb-5 flex flex-column" style="margin-top: -35px;">
          <span class="mb-4 mt-2 tipo-contabilidade">Cadastro para recebimento em Pessoa Jurídica</span>
          <div class="flex align-items-center mb-5">
            <p-inputSwitch class="ml-2 flex" formControlName="socioAdministrador"
              (onChange)="ativarSocioAdministrador()"></p-inputSwitch>
            <span class="label-switch -ml-1 texto-info">Sou sócio administrador</span>
          </div>
          <div class="flex align-items-center mb-5">
            <p-inputSwitch class="ml-2 flex" formControlName="simplifiedInvoiceDescription"></p-inputSwitch>
            <span class="label-switch -ml-1 texto-info flex align-items-center">
              Ocultar dados pessoais na nota
              <img [pTooltip]="simplifiedInvoiceTooltip" class="pl-1" src="assets\\icons\\akar-icons_info-fill.svg" alt="informações da nota" />
            </span>
          </div>

          <div class="grid p-fluid mb-4">
            <div class="col-12 company_register_title mb-3">
              Informações da Pessoa Jurídica
            </div>
            <ng-container formGroupName="company">
              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <p-inputMask [unmask]="true" id="cnpj" formControlName="registrationNumber" mask="99.999.999/9999-99">
                  </p-inputMask>
                  <label htmlFor="cnpj" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                    CNPJ
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>
              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <p-inputNumber formControlName="annualRevenue" id="valor" mode="currency" currency="BRL"
                    locale="pt-BR" currencyDisplay="symbol"> </p-inputNumber>
                  <label htmlFor="valor" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                    Receita Anual
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>
              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <input pInputText id="razao-social" formControlName="legalName" />
                  <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                    Razão Social
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>

              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <input pInputText id="nome-fantasia" formControlName="tradeName" />
                  <label htmlFor="nome-fantasia" class="text-xs pl-1 h-1rem flex align-items-center">
                    Nome Fantasia
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>
              <div class="col-8 mb-3">
                <span class="p-float-label">
                  <input pInputText id="email" formControlName="legalEmail" />
                  <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                    Email Contabilidade
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>
              <div class="col-4 mb-3">
                <span class="p-float-label">
                  <input pInputText mask="(00) 00000-0000||(00) 0000-0000" id="telefone" formControlName="contactNumber" />
                  <!--<p-inputMask [unmask]="true" [autoClear]="false" id="telefone" formControlName="contactNumber"
                    mask="(99) 99999-9999"> </p-inputMask>-->
                  <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                    Celular
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>
              <ng-container formGroupName="address">
                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <p-inputMask #cep [unmask]="true" id="cep" formControlName="postalCode" mask="99999-999"
                      (onComplete)="autoCompleteAddress(cep.value!, 'company')">
                    </p-inputMask>
                    <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center">
                      CEP
                      <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" />
                    </label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                      (onChange)="loadCitiesByUF($event.value, true)" [filter]="true" filterBy="name"
                      [options]="stateList" optionLabel="name" optionValue="uf" id="estado"
                      formControlName="state"></p-dropdown>

                    <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                      Estado <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" />
                    </label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">

                    <div
                      class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
                      *ngIf="isLoadingCities">
                      Aguarde...

                    </div>

                    <span class="p-float-label" *ngIf="!isLoadingCities">
                      <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'" [filter]="true" filterBy="nome"
                        [options]="citiesListPJ" id="cidade" formControlName="city" optionLabel="nome" optionValue="id"
                        inputId="float-label"></p-dropdown>
                      <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                        Cidade <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </span>
                </div>

                <div class="col-8 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="logradouro" formControlName="streetAddress" />
                    <label htmlFor="logradouro" class="text-xs pl-1 h-1rem flex align-items-center">Logradouro <img
                        class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" /></label>
                  </span>
                </div>
                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="bairro" formControlName="district" />
                    <label htmlFor="bairro" class="text-xs pl-1 h-1rem flex align-items-center">Bairro <img class="pl-1"
                        src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="numero" formControlName="number" />
                    <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center">Número <img class="pl-1"
                        src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>

                  </span>
                </div>

                <div class="col-8 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="complemento" formControlName="address2" />
                    <label htmlFor="complemento" class="text-xs pl-2">Complemento
                    </label>
                  </span>
                </div>

              </ng-container>

            </ng-container>

            <ng-container *ngIf="!form.value.socioAdministrador">
              <div class="col-12 company_register_title mb-3">
                Informações do Sócio Adminitrador
              </div>

              <ng-container formGroupName="company">
                <ng-container formGroupName="representative">
                  <div class="col-8 mb-3">
                    <span class="p-float-label">
                      <input pInputText id="nome-completo" formControlName="name" />
                      <label htmlFor="nome-completo" class="text-xs pl-1 h-1rem flex align-items-center"
                        for="float-label">
                        Nome Completo
                        <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </div>
                  <div class="col-4 mb-3">
                    <span class="p-float-label">
                      <p-inputMask [unmask]="true" formControlName="birthdate" mask="99/99/9999" />
                      <label htmlFor="data-nascimento" class="text-xs pl-1 h-1rem flex align-items-center">
                        Data de Nascimento
                        <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />

                      </label>
                    </span>
                  </div>
                  <div class="col-8 mb-3">
                    <span class="p-float-label">
                      <input pInputText id="emailRepresentative" formControlName="representativeEmail" />
                      <label htmlFor="emailRepresentative" class="text-xs pl-1 h-1rem flex align-items-center"
                        for="float-label">
                        Email
                        <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </div>
                  <div class="col-4 mb-3">
                    <span class="p-float-label">
                      <p-inputMask [class.p-disabled]="isEdit" [unmask]="true" [autoClear]="false" id="taxId" formControlName="taxId"
                        mask="999.999.999-99"> </p-inputMask>
                      <label htmlFor="taxId" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                        CPF
                        <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </div>
                  <!-- <div class="col-4 mb-3">
                    <span class="p-float-label">
                      <p-dropdown inputId="multiselect" [appendTo]="'body'" [options]="(profissaoLista$ | async)!"
                        [filter]="true" filterBy="name" optionLabel="name" optionValue="@id"
                        formControlName="profession"></p-dropdown>
                      <label class="pl-1 h-1rem flex align-items-center" for="cpf">Profissão <img class="pl-1"
                          src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
                    </span>
                  </div> -->
                  <div class="col-6 mb-3">
                    <span class="p-float-label">
                      <p-inputNumber formControlName="monthlyIncome" id="valor" mode="currency" currency="BRL"
                        locale="pt-BR" currencyDisplay="symbol"> </p-inputNumber>
                      <label htmlFor="valor" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                        Renda Mensal
                        <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </div>
                  <div class="col-6 mb-3">
                    <span class="p-float-label">
                      <input pInputText mask="(00) 00000-0000||(00) 0000-0000" id="telefone" formControlName="contactNumber" />
                      <!--<p-inputMask [unmask]="true" [autoClear]="false" id="telefone" formControlName="contactNumber"
                        mask="(99) 99999-9999"> </p-inputMask>-->
                      <label class="pl-1 h-1rem flex align-items-center" for="cpf">Celular <img class="pl-1"
                          src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
                    </span>
                  </div>
                  <ng-container formGroupName="address">
                    <div class="col-4 mb-3">
                      <span class="p-float-label">
                        <p-inputMask #cep [unmask]="true" id="cep" formControlName="postalCode" mask="99999-999"
                          (onComplete)="autoCompleteAddress(cep.value!, 'company.representative')">
                        </p-inputMask>
                        <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center">
                          CEP
                          <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                            alt="alerta-campo-vazio" />
                        </label>
                      </span>
                    </div>

                    <div class="col-4 mb-3">
                      <span class="p-float-label">
                        <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                          (onChange)="loadCitiesByUF($event.value)" [filter]="true" filterBy="name"
                          [options]="stateList" optionLabel="name" optionValue="uf" id="estado"
                          formControlName="state"></p-dropdown>

                        <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                          Estado <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                            alt="alerta-campo-vazio" />
                        </label>
                      </span>
                    </div>

                    <div class="col-4 mb-3">
                      <span class="p-float-label">

                        <div
                          class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
                          *ngIf="isLoadingCities">
                          Aguarde...

                        </div>

                        <span class="p-float-label" *ngIf="!isLoadingCities">
                          <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'" [filter]="true"
                            filterBy="nome" [options]="citiesListPF" id="cidade" formControlName="city"
                            optionLabel="nome" optionValue="id" inputId="float-label"></p-dropdown>
                          <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                            Cidade <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                              alt="alerta-campo-vazio" />
                          </label>
                        </span>
                      </span>
                    </div>

                    <div class="col-8 mb-3">
                      <span class="p-float-label">
                        <input pInputText id="logradouro" formControlName="streetAddress" />
                        <label htmlFor="logradouro" class="text-xs pl-1 h-1rem flex align-items-center">Logradouro
                          <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                            alt="alerta-campo-vazio" /></label>
                      </span>
                    </div>
                    <div class="col-4 mb-3">
                      <span class="p-float-label">
                        <input pInputText id="bairro" formControlName="district" />
                        <label htmlFor="bairro" class="text-xs pl-1 h-1rem flex align-items-center">Bairro <img
                            class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                            alt="alerta-campo-vazio" /></label>
                      </span>
                    </div>

                    <div class="col-4 mb-3">
                      <span class="p-float-label">
                        <input pInputText id="numero" formControlName="number" />
                        <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center">Número <img
                            class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                            alt="alerta-campo-vazio" /></label>

                      </span>
                    </div>

                    <div class="col-8 mb-3">
                      <span class="p-float-label">
                        <input pInputText id="complemento" formControlName="address2" />
                        <label htmlFor="complemento" class="text-xs pl-2">Complemento
                        </label>
                      </span>
                    </div>

                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="form.value.socioAdministrador">
              <div class="col-12 company_register_title mb-3">
                Informações do Profissional
                <img [pTooltip]="professionalIsRepresentativeMessage" class="pl-1"
                  src="assets\icons\akar-icons_info-fill.svg" alt="alerta-campo-vazio" />
                <ng-template #professionalIsRepresentativeMessage>
                  <div class="flex align-items-start justify-content-center flex-column">
                    Se o profissional se identifica como Sócio Administrador, precisamos de algumas informações
                    adicionais.
                  </div>
                </ng-template>
              </div>

              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <p-inputMask [unmask]="true" formControlName="birthdate" mask="99/99/9999" />
                  <label htmlFor="data-nascimento" class="text-xs pl-1 h-1rem flex align-items-center">
                    Data de Nascimento
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />

                  </label>
                </span>
              </div>

              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <p-inputNumber formControlName="monthlyIncome" id="valor" mode="currency" currency="BRL"
                    locale="pt-BR" currencyDisplay="symbol"> </p-inputNumber>
                  <label htmlFor="valor" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                    Renda Mensal
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>

              <ng-container formGroupName="address">
                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <p-inputMask #cep [unmask]="true" id="cep" formControlName="postalCode" mask="99999-999"
                      (onComplete)="autoCompleteAddress(cep.value!, null)">
                    </p-inputMask>
                    <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center">
                      CEP
                      <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" />
                    </label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                      (onChange)="loadCitiesByUF($event.value)" [filter]="true" filterBy="name" [options]="stateList"
                      optionLabel="name" optionValue="uf" id="estado" formControlName="state"></p-dropdown>

                    <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                      Estado <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" />
                    </label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">

                    <div
                      class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
                      *ngIf="isLoadingCities">
                      Aguarde...

                    </div>

                    <span class="p-float-label" *ngIf="!isLoadingCities">
                      <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'" [filter]="true" filterBy="nome"
                        [options]="citiesListPF" id="cidade" formControlName="city" optionLabel="nome" optionValue="id"
                        inputId="float-label"></p-dropdown>
                      <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                        Cidade <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </span>
                </div>

                <div class="col-8 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="logradouro" formControlName="streetAddress" />
                    <label htmlFor="logradouro" class="text-xs pl-1 h-1rem flex align-items-center">Logradouro
                      <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" /></label>
                  </span>
                </div>
                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="bairro" formControlName="district" />
                    <label htmlFor="bairro" class="text-xs pl-1 h-1rem flex align-items-center">Bairro <img class="pl-1"
                        src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="numero" formControlName="number" />
                    <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center">Número <img class="pl-1"
                        src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>

                  </span>
                </div>

                <div class="col-8 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="complemento" formControlName="address2" />
                    <label htmlFor="complemento" class="text-xs pl-2">Complemento
                    </label>
                  </span>
                </div>

              </ng-container>


            </ng-container>
          </div>

          <span class="text-xs flex align-items-center texto-info mb-2">
            <p-checkbox class="mr-2" [binary]="true" inputId="binary"
              formControlName="selfDeclaredLegalRepresentative"></p-checkbox>
            Garanto que esse cadastro de pessoal física se identifica como representante legal do CNPJ do recebedor ao
            qual está atrelado.
          </span>
          <span class="text-xs flex align-items-center texto-info mb-4">
            <p-checkbox class="mr-2" [binary]="true" inputId="binary" formControlName="acceptTermsPf"></p-checkbox>
            Estou ciente que irei receber em minha pessoa jurídica e Split Pay
            não se responsabiliza pelo método escolhido.
          </span>

        </form>
      </ng-container>

      <ng-container *ngIf="contabilidadeSelecionada === 'pj-emissao-automatica-nf'">
        <form [formGroup]="form" class="pb-5 flex flex-column" style="margin-top: -35px;">
          <span class="mb-4 mt-2 tipo-contabilidade">Cadastro para recebimento em Pessoa Jurídica com emissão de NF
            automática</span>
          <div class="flex align-items-center mb-5">
            <p-inputSwitch class="ml-2 flex" formControlName="socioAdministrador"
              (onChange)="ativarSocioAdministrador()"></p-inputSwitch>
            <span class="label-switch texto-info">Sou sócio administrador</span>
          </div>
          <div class="flex align-items-center mb-5">
            <p-inputSwitch class="ml-2 flex" formControlName="simplifiedInvoiceDescription"></p-inputSwitch>
            <span class="label-switch texto-info flex align-items-center">
              Ocultar dados pessoais na nota
              <img [pTooltip]="simplifiedInvoiceTooltip" class="pl-1" src="assets\\icons\\akar-icons_info-fill.svg" alt="informações da nota" />
            </span>
          </div>

          <div class="grid p-fluid mb-4">
            <div class="col-12 company_register_title mb-3">
              Informações da Pessoa Jurídica
            </div>
            <ng-container formGroupName="company">
              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <p-inputMask [unmask]="true" id="cnpj" formControlName="registrationNumber" mask="99.999.999/9999-99">
                  </p-inputMask>
                  <label htmlFor="cnpj" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                    CNPJ
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>
              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <p-inputNumber formControlName="annualRevenue" id="valor" mode="currency" currency="BRL"
                    locale="pt-BR" currencyDisplay="symbol"> </p-inputNumber>
                  <label htmlFor="valor" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                    Receita Anual
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>
              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <input pInputText id="razao-social" formControlName="legalName" />
                  <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                    Razão Social
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>

              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <input pInputText id="nome-fantasia" formControlName="tradeName" />
                  <label htmlFor="nome-fantasia" class="text-xs pl-1 h-1rem flex align-items-center">
                    Nome Fantasia
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>

              <div class="col-3 mb-3">
                <span class="p-float-label" formGroupName="taxInfo">

                  <p-dropdown [options]="tiposRegimeTributario" [autoDisplayFirst]="false" optionLabel="name"
                    optionValue="@id" inputId="regimeTributario" formControlName="taxRegime">
                  </p-dropdown>
                  <label class="text-xs pl-1 h-1rem flex align-items-center" for="regimeTributario">
                    Regime Tributário
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>

                </span>
              </div>

              <div class="col-3 mb-3">
                <span class="p-float-label" formGroupName="taxInfo">
                  <input pInputText id="inscricao-estadual" formControlName="stateRegistration" />
                  <label htmlFor="inscricao-estadual" class="text-xs pl-2">Inscrição Estadual
                  </label>
                </span>
              </div>

              <div class="col-3 mb-3">
                <span class="p-float-label" formGroupName="taxInfo">
                  <input pInputText id="inscricao-municipal" formControlName="municipalRegistration" />
                  <label htmlFor="inscricao-municipal" class="text-xs pl-1 h-1rem flex align-items-center">Inscrição
                    Municipal
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>

              <div class="col-3 mb-3">
                <label class="label-sticky text-xs pl-1 h-1rem flex align-items-center">
                  <img [pTooltip]="tooltipISS" class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                    alt="alerta-campo-vazio" />
                </label>
                <span class="p-float-label -mt-3" formGroupName="taxInfo" [ngClass]="{ 'inativo' : form.value.company?.taxInfo?.taxRegime != '/api/tax_regimes/1'}">

                  <p-inputNumber id="aliquota-iss-simples" formControlName="issRate" [minFractionDigits]="1"
                    mode="decimal" suffix=" %">
                  </p-inputNumber>

                  <label htmlFor="aliquota-iss-simples" class="text-xs pl-1 h-1rem flex align-items-center"
                    for="float-label">
                    Aliquota ISS Simples Nacional
                  </label>

                </span>
                <ng-template #tooltipISS>
                  <div class="flex align-items-start justify-content-center flex-column">
                    É a taxa do Simples Nacional na sua Cidade. Caso seu modelo não
                    seja simples nacional, será calculado automaticamente.
                  </div>
                </ng-template>
              </div>
              <div class="col-8 mb-3">
                <span class="p-float-label">
                  <input pInputText id="email" formControlName="legalEmail" />
                  <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                    Email Contabilidade
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>
              <div class="col-4 mb-3">
                <span class="p-float-label">
                  <input pInputText mask="(00) 00000-0000||(00) 0000-0000" id="telefone" formControlName="contactNumber" />
                  <!--<p-inputMask [unmask]="true" [autoClear]="false" id="telefone" formControlName="contactNumber"
                    mask="(99) 99999-9999"> </p-inputMask>-->
                  <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                    Celular
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>
              <ng-container formGroupName="address">
                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <p-inputMask #cep [unmask]="true" id="cep" formControlName="postalCode" mask="99999-999"
                      (onComplete)="autoCompleteAddress(cep.value!, 'company')">
                    </p-inputMask>
                    <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center">
                      CEP
                      <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" />
                    </label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                      (onChange)="loadCitiesByUF($event.value, true)" [filter]="true" filterBy="name"
                      [options]="stateList" optionLabel="name" optionValue="uf" id="estado"
                      formControlName="state"></p-dropdown>

                    <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                      Estado <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" />
                    </label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">

                    <div
                      class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
                      *ngIf="isLoadingCities">
                      Aguarde...

                    </div>

                    <span class="p-float-label" *ngIf="!isLoadingCities">
                      <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'" [filter]="true" filterBy="nome"
                        [options]="citiesListPJ" id="cidade" formControlName="city" optionLabel="nome" optionValue="id"
                        inputId="float-label"></p-dropdown>
                      <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                        Cidade <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </span>
                </div>

                <div class="col-8 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="logradouro" formControlName="streetAddress" />
                    <label htmlFor="logradouro" class="text-xs pl-1 h-1rem flex align-items-center">Logradouro <img
                        class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" /></label>
                  </span>
                </div>
                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="bairro" formControlName="district" />
                    <label htmlFor="bairro" class="text-xs pl-1 h-1rem flex align-items-center">Bairro <img class="pl-1"
                        src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="numero" formControlName="number" />
                    <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center">Número <img class="pl-1"
                        src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>

                  </span>
                </div>

                <div class="col-8 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="complemento" formControlName="address2" />
                    <label htmlFor="complemento" class="text-xs pl-2">Complemento
                    </label>
                  </span>
                </div>

              </ng-container>

            </ng-container>

            <ng-container *ngIf="!form.value.socioAdministrador">
              <div class="col-12 company_register_title mb-3">
                Informações do Sócio Adminitrador
              </div>

              <ng-container formGroupName="company">
                <ng-container formGroupName="representative">
                  <div class="col-8 mb-3">
                    <span class="p-float-label">
                      <input pInputText id="nome-completo" formControlName="name" />
                      <label htmlFor="nome-completo" class="text-xs pl-1 h-1rem flex align-items-center"
                        for="float-label">
                        Nome Completo
                        <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </div>
                  <div class="col-4 mb-3">
                    <span class="p-float-label">
                      <p-inputMask [unmask]="true" formControlName="birthdate" mask="99/99/9999" />
                      <label htmlFor="data-nascimento" class="text-xs pl-1 h-1rem flex align-items-center">
                        Data de Nascimento
                        <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />

                      </label>
                    </span>
                  </div>
                  <div class="col-8 mb-3">
                    <span class="p-float-label">
                      <input pInputText id="emailRepresentative" formControlName="representativeEmail" />
                      <label htmlFor="emailRepresentative" class="text-xs pl-1 h-1rem flex align-items-center"
                        for="float-label">
                        Email
                        <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </div>
                  <div class="col-4 mb-3">
                    <span class="p-float-label">
                      <p-inputMask [class.p-disabled]="isEdit" [unmask]="true" [autoClear]="false" id="taxId" formControlName="taxId"
                        mask="999.999.999-99"> </p-inputMask>
                      <label htmlFor="taxId" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                        CPF
                        <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </div>
                  <!-- <div class="col-4 mb-3">
                    <span class="p-float-label">
                      <p-dropdown inputId="multiselect" [appendTo]="'body'" [options]="(profissaoLista$ | async)!"
                        [filter]="true" filterBy="name" optionLabel="name" optionValue="@id"
                        formControlName="profession"></p-dropdown>
                      <label class="pl-1 h-1rem flex align-items-center" for="cpf">Profissão <img class="pl-1"
                          src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
                    </span>
                  </div> -->
                  <div class="col-6 mb-3">
                    <span class="p-float-label">
                      <p-inputNumber formControlName="monthlyIncome" id="valor" mode="currency" currency="BRL"
                        locale="pt-BR" currencyDisplay="symbol"> </p-inputNumber>
                      <label htmlFor="valor" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                        Renda Mensal
                        <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </div>
                  <div class="col-6 mb-3">
                    <span class="p-float-label">
                      <input pInputText mask="(00) 00000-0000||(00) 0000-0000" id="telefone" formControlName="contactNumber" />
                      <!--<p-inputMask [unmask]="true" [autoClear]="false" id="telefone" formControlName="contactNumber"
                        mask="(99) 99999-9999"> </p-inputMask>-->
                      <label class="pl-1 h-1rem flex align-items-center" for="cpf">Celular <img class="pl-1"
                          src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
                    </span>
                  </div>
                  <ng-container formGroupName="address">
                    <div class="col-4 mb-3">
                      <span class="p-float-label">
                        <p-inputMask #cep [unmask]="true" id="cep" formControlName="postalCode" mask="99999-999"
                          (onComplete)="autoCompleteAddress(cep.value!, 'company.representative')">
                        </p-inputMask>
                        <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center">
                          CEP
                          <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                            alt="alerta-campo-vazio" />
                        </label>
                      </span>
                    </div>

                    <div class="col-4 mb-3">
                      <span class="p-float-label">
                        <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                          (onChange)="loadCitiesByUF($event.value)" [filter]="true" filterBy="name"
                          [options]="stateList" optionLabel="name" optionValue="uf" id="estado"
                          formControlName="state"></p-dropdown>

                        <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                          Estado <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                            alt="alerta-campo-vazio" />
                        </label>
                      </span>
                    </div>

                    <div class="col-4 mb-3">
                      <span class="p-float-label">

                        <div
                          class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
                          *ngIf="isLoadingCities">
                          Aguarde...

                        </div>

                        <span class="p-float-label" *ngIf="!isLoadingCities">
                          <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'" [filter]="true"
                            filterBy="nome" [options]="citiesListPF" id="cidade" formControlName="city"
                            optionLabel="nome" optionValue="id" inputId="float-label"></p-dropdown>
                          <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                            Cidade <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                              alt="alerta-campo-vazio" />
                          </label>
                        </span>
                      </span>
                    </div>

                    <div class="col-8 mb-3">
                      <span class="p-float-label">
                        <input pInputText id="logradouro" formControlName="streetAddress" />
                        <label htmlFor="logradouro" class="text-xs pl-1 h-1rem flex align-items-center">Logradouro
                          <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                            alt="alerta-campo-vazio" /></label>
                      </span>
                    </div>
                    <div class="col-4 mb-3">
                      <span class="p-float-label">
                        <input pInputText id="bairro" formControlName="district" />
                        <label htmlFor="bairro" class="text-xs pl-1 h-1rem flex align-items-center">Bairro <img
                            class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                            alt="alerta-campo-vazio" /></label>
                      </span>
                    </div>

                    <div class="col-4 mb-3">
                      <span class="p-float-label">
                        <input pInputText id="numero" formControlName="number" />
                        <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center">Número <img
                            class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                            alt="alerta-campo-vazio" /></label>

                      </span>
                    </div>

                    <div class="col-8 mb-3">
                      <span class="p-float-label">
                        <input pInputText id="complemento" formControlName="address2" />
                        <label htmlFor="complemento" class="text-xs pl-2">Complemento
                        </label>
                      </span>
                    </div>

                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="form.value.socioAdministrador">
              <div class="col-12 company_register_title mb-3">
                Informações do Profissional
                <img [pTooltip]="professionalIsRepresentativeMessage" class="pl-1"
                  src="assets\icons\akar-icons_info-fill.svg" alt="alerta-campo-vazio" />
                <ng-template #professionalIsRepresentativeMessage>
                  <div class="flex align-items-start justify-content-center flex-column">
                    Se o profissional se identifica como Sócio Administrador, precisamos de algumas informações
                    adicionais.
                  </div>
                </ng-template>
              </div>

              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <p-inputMask [unmask]="true" formControlName="birthdate" mask="99/99/9999" />
                  <label htmlFor="data-nascimento" class="text-xs pl-1 h-1rem flex align-items-center">
                    Data de Nascimento
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />

                  </label>
                </span>
              </div>

              <div class="col-6 mb-3">
                <span class="p-float-label">
                  <p-inputNumber formControlName="monthlyIncome" id="valor" mode="currency" currency="BRL"
                    locale="pt-BR" currencyDisplay="symbol"> </p-inputNumber>
                  <label htmlFor="valor" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                    Renda Mensal
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>

              <ng-container formGroupName="address">
                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <p-inputMask #cep [unmask]="true" id="cep" formControlName="postalCode" mask="99999-999"
                      (onComplete)="autoCompleteAddress(cep.value!, null)">
                    </p-inputMask>
                    <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center">
                      CEP
                      <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" />
                    </label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                      (onChange)="loadCitiesByUF($event.value)" [filter]="true" filterBy="name" [options]="stateList"
                      optionLabel="name" optionValue="uf" id="estado" formControlName="state"></p-dropdown>

                    <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                      Estado <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" />
                    </label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">

                    <div
                      class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
                      *ngIf="isLoadingCities">
                      Aguarde...

                    </div>

                    <span class="p-float-label" *ngIf="!isLoadingCities">
                      <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'" [filter]="true" filterBy="nome"
                        [options]="citiesListPF" id="cidade" formControlName="city" optionLabel="nome" optionValue="id"
                        inputId="float-label"></p-dropdown>
                      <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                        Cidade <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                          alt="alerta-campo-vazio" />
                      </label>
                    </span>
                  </span>
                </div>

                <div class="col-8 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="logradouro" formControlName="streetAddress" />
                    <label htmlFor="logradouro" class="text-xs pl-1 h-1rem flex align-items-center">Logradouro
                      <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" /></label>
                  </span>
                </div>
                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="bairro" formControlName="district" />
                    <label htmlFor="bairro" class="text-xs pl-1 h-1rem flex align-items-center">Bairro <img class="pl-1"
                        src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
                  </span>
                </div>

                <div class="col-4 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="numero" formControlName="number" />
                    <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center">Número <img class="pl-1"
                        src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>

                  </span>
                </div>

                <div class="col-8 mb-3">
                  <span class="p-float-label">
                    <input pInputText id="complemento" formControlName="address2" />
                    <label htmlFor="complemento" class="text-xs pl-2">Complemento
                    </label>
                  </span>
                </div>

              </ng-container>


            </ng-container>
          </div>

          <span class="text-xs flex align-items-center texto-info mb-2">
            <p-checkbox class="mr-2" [binary]="true" inputId="binary"
              formControlName="selfDeclaredLegalRepresentative"></p-checkbox>
            Garanto que esse cadastro de pessoal física se identifica como representante legal do CNPJ do recebedor ao
            qual está atrelado.
          </span>
          <span class="text-xs flex align-items-center texto-info mb-4">
            <p-checkbox class="mr-2" [binary]="true" inputId="binary" formControlName="acceptTermsPf"></p-checkbox>
            Estou ciente que irei receber em minha pessoa jurídica e Split Pay
            não se responsabiliza pelo método escolhido.
          </span>


        </form>
      </ng-container>
    </split-step>

    <split-step [passo]="3">
      <form [formGroup]="uploadCertificateForm">

        <p-messages severity="warn" *ngIf="form.value.taxInfo?.digitalCertificationFile?.length">
          <ng-template pTemplate>
            <div class="border-none pl-0">Já existe um certificado carregado para esse CNPJ. <a (click)="downloadDigitalCertificationFile(form.value.taxInfo?.digitalCertificationFile)"  target="_blank" [style.color]="'#1A88CB'">  Clique aqui </a> para baixá-lo. </div>
          </ng-template>
        </p-messages>

        <p-messages severity="warn" *ngIf="!uploadCertificateForm.value.partnerId?.length">
          <ng-template pTemplate>
            <div class="border-none pl-0">
              Não foi possível carregar os dados fiscais, verifique os dados ou tente novamente mais tarde.
            </div>
          </ng-template>
        </p-messages>

        <div class="grid p-fluid" [ngClass]="{ 'mt-5' : form.value.taxInfo?.digitalCertificationFile?.length || !uploadCertificateForm.value.partnerId?.length}" >

          <div class="col-12" [ngClass]=" { 'inativo' : !uploadCertificateForm.value.partnerId?.length }">
            <span class="p-float-label mb-3">
              <p-password formControlName="password" [feedback]="false" [toggleMask]="true"> </p-password>
              <label for="password">Senha</label>
            </span>
          </div>

          <div class="col-12" [ngClass]=" { 'inativo' : !uploadCertificateForm.value.partnerId?.length }">
            <p-fileUpload [customUpload]="true" chooseLabel="CARREGAR ARQUIVO" [showUploadButton]="false"
              [showCancelButton]="false" class="mb-3" (onSelect)="setFile($event)" (onRemove)="setFile($event, true)"
              [multiple]="false" accept=".pfx" chooseIcon="pi pi-cloud-upload">
              <ng-template pTemplate="content">
                <div class="flex justify-content-center text-base" id="dragdropMessage">
                  {{dragdropMessage}}
                </div>
              </ng-template>
            </p-fileUpload>
          </div>

          <div class="col-12" [ngClass]=" { 'inativo' : !uploadCertificateForm.value.partnerId?.length }">
            <div class="flex justify-content-center mb-5">
              <p-button [disabled]="this.uploadCertificateForm.invalid || !certificateFile" label="Enviar Certificado" (click)="OnUpload()"
                severity="primary"></p-button>
  
            </div>
          </div>

        </div>


      </form>
    </split-step>

    <split-step [passo]="4">
      <ng-container *ngIf="exibeServicoForm">
        <app-profissional-servico-form  *ngIf="professionalId" #servico [professionalId]="professionalId"
          ></app-profissional-servico-form>
      </ng-container>
      <ng-container *ngIf="!exibeServicoForm">
        <split-table card-body [dados]="(selectProfessionalServicoLista$ | async)!" [checklist]="false" theme="primary">
          <ng-template #header>Id</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            {{item.id}}
          </ng-template>

          <ng-template #header> 
            <div class="ml-3 text-left">
              Tipo
            </div> 
          </ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <split-text [title]="item.name" [subtitle]="item.specialty ? item.specialty.name : ''"></split-text>
          </ng-template>

          <!--
          <ng-template #header>Tempo de Consulta</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            {{item.duration}} minutos
          </ng-template>
          -->
          <ng-template #header>Valor/Repasse</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            R${{item.value}} / R${{item.transferValue}}
          </ng-template>

          <ng-template #header></ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div class="flex justify-content-end w-auto">
              <button class="editar border-none bg-white mr-4 action w-2rem h-2rem" (click)="editarServico(item)"
                pTooltip="Editar Serviço">
                <img src="assets/lista-unidade/editar.svg" alt="editar serviço" />
              </button>
              <button class="excluir border-none bg-white mr-5 action w-2rem h-2rem" (click)="deletarServico(item.id)"
                pTooltip="Deletar Serviço">
                <img src="assets/lista-unidade/excluir.svg" alt="deletar serviço" />
              </button>
            </div>
          </ng-template>

        </split-table>

        <div class="flex justify-content-center align-items-center mt-5 mb-6">
          <button class="btn-add-new" (click)="changeServico()">Adicionar Novo Serviço</button>
        </div>
      </ng-container>
    </split-step>

    <ng-template #customNextButton *ngIf="steps.activeIndex == 0">
      <div class="w-100 text-right">
        <ng-container *ngIf="this.form.get('split')?.value == false; else nextStep">
          <p-button [ngClass]="{'inativo': validationStepProfessional}" [disabled]="validationStepProfessional"
            (onClick)="saveProfessional()" label="Salvar"></p-button>
        </ng-container>
        <ng-template #nextStep>
          <button class="s-step__button-next" (click)="steps.nextStep()" [disabled]="validationStepProfessional"
            [ngClass]="{'disabled': validationStepProfessional}">
            Próximo <i class="pi pi-arrow-right ml-3"></i>
          </button>
        </ng-template>
      </div>
    </ng-template>

    <ng-template #customNextButton *ngIf="steps.activeIndex == 1">
      
    </ng-template>

    <ng-template #customNextButton *ngIf="steps.activeIndex == 2">
      <div class="w-100 text-right">
        <p-button [disabled]="validateContabil" [ngClass]="{'inativo': validateContabil}"
          (onClick)="saveProfessinalInContabilidade()" label="Salvar"></p-button>

      </div>
    </ng-template>

    <ng-template #customPreviousButton *ngIf="steps.activeIndex == 3">
      <div class="w-100 text-left">
        <button class="s-step__button-previous" (click)="onSetSecondStep()">
          <i class="pi pi-arrow-left mr-3"></i>Anterior</button>
      </div>
    </ng-template>

    <ng-template #customNextButton *ngIf="steps.activeIndex == 4 && exibeServicoForm && !form.value.split">
      <div class="w-100 text-right">
        <p-button [disabled]="validateService" [ngClass]="{'inativo': validateService}" (onClick)="salvarServico()"
          label="Salvar"></p-button>
      </div>
    </ng-template>

    <ng-template #customPreviousButton *ngIf="steps.activeIndex == 4">
      <div class="w-100 text-left">
        <button class="s-step__button-previous" (click)="verifyFormService()" [disabled]="activeIndex === 0">
          <i class="pi pi-arrow-left mr-3"></i>Anterior</button>
      </div>
    </ng-template>

    <ng-template #customNextButton *ngIf="steps.activeIndex == 4 && !exibeServicoForm && !form.value.split">
      <div class="w-100 text-right">
        <p-button (onClick)="fecharModal()" label="FINALIZAR"></p-button>
      </div>
    </ng-template>


    <ng-template #customNextButton *ngIf="steps.activeIndex == 4 && exibeServicoForm && form.value.split">
      <div class="w-100 text-right">
        <p-button [disabled]="validateService" [ngClass]="{'inativo': validateService}" (onClick)="salvarServico()"
          label="Salvar"></p-button>
      </div>
    </ng-template>

    <!-- <ng-template #customPreviousButton *ngIf="steps.activeIndex == 4 && exibeServicoForm && form.value.split">
      <div class="w-100 text-left">
        <button class="s-step__button-previous" (click)="verifyFormService()" [disabled]="activeIndex === 0">
          <i class="pi pi-arrow-left mr-3"></i>Anterior</button>
      </div>
    </ng-template> -->

    <ng-template #customNextButton *ngIf="steps.activeIndex == 4 && !exibeServicoForm && form.value.split">

      <div class="w-100 text-right">
        <p-button (onClick)="fecharModal()" label="FINALIZAR"></p-button>
      </div>
    </ng-template>

    <!-- <ng-template #customPreviousButton *ngIf="steps.activeIndex == 4 && !form.value.split">

      <div class="w-100 text-left">
        <button class="s-step__button-previous" (click)="setFirstStep()">
          <i class="pi pi-arrow-left mr-3"></i>Anterior</button>
      </div>
    </ng-template> -->

  </split-steps>


  <ng-container card-body>
    <div
      *ngIf="isLoadingProfessional == true || !(profissaoLista$ | async)?.length || (professionalState$ | async)?.type == 'loading' || isUploadLoading || (selectProfessionalServiceState$ | async)?.type == 'loading'"
      class="flex align-items-center justify-content-center">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
  </ng-container>
</div>
